import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IAppointment } from 'src/app/models/IAppointment';

@Component({
  selector: 'app-doctor-schedule',
  templateUrl: './doctor-schedule.component.html',
  styleUrls: ['./doctor-schedule.component.scss']
})
export class DoctorScheduleComponent implements OnInit {
  specialties: SelectItem[];
  selectedSpecialty:any;
  doctors: SelectItem[];
  selectedDoctor:any;
  dateCriteria: SelectItem[];
  selectedDate:any;
  dir='rtl';

  doctorAppointments:IAppointment[];
  cols: any[];
  isLoading:boolean;
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  satDate:string='';
  sunDate:string='';
  monDate:string='';
  tuesDate:string='';
  wedDate:string='';
  thurDate:string='';
  firdDate:string='';

  selectedCustomDate:any = new Date;
  isDisableCustomDate :boolean = true;
  constructor(private helperService:HttphelperService,private messageService: MessageService,private cd:ChangeDetectorRef) {}

  ngOnInit(): void {
    this.cols = [
      {field: 'SpecialtyName', header: 'التخصص'},
      {field: 'PersonNameA', header: 'الدكتور'},
      {field: 'Saturday', header: 'السبت'},
      {field: 'Sunday', header: 'الاحد'},
      {field: 'Monday', header: 'الاثنين'},
      {field: 'Tuesday', header: 'الثلاثاء'},
      {field: 'Wednesday', header: 'الاربعاء'},
      {field: 'Thursday', header: 'الخميس'},
      {field: 'Friday', header: 'الجمعه'}
    ];
    this.selectedDate = "2";
    this.loadSpecialtiesData();
    this.loadDoctorsData();
    this.loadDateCriteria();
    this.SetColHeadersWithDates();
  }
  loadSpecialtiesData()
  {
    var specialityUrl = `/api/Queue/GetAllSpecialties?doctorId=${this.selectedDoctor}`;
    this.helperService.getRequest(specialityUrl).subscribe(response => {
      if(response.Success)
      {
        this.specialties = response?.Data;
      }
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'While getting specialties', detail: error, life: 2000});
    })
  }
  changeSpeciality()
  {
    this.loadDoctorsData();
  }
  changeDoctor()
  {
    this.loadSpecialtiesData();
  }
  changeDateCriteria(){
    if(this.selectedDate == 4)
    {
      this.isDisableCustomDate = false;
    }
    else
    {
      this.isDisableCustomDate = true;
    }
    this.SetColHeadersWithDates();
    this.doctorAppointments = [];
  }
  selectDateCustom(){
    this.doctorAppointments = [];
    this.SetColHeadersWithDates();
  }
  loadDoctorsData()
  {
    var doctorUrl = `/api/Queue/GetAllDoctors?specialtyId=${this.selectedSpecialty}`;
    this.helperService.getRequest(doctorUrl).subscribe(response => {
      if(response.Success)
      {
        this.doctors = response?.Data;
      }
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'While getting doctors', detail: error, life: 2000});
    })
  }
  loadDateCriteria()
  {
    this.dateCriteria = [
      { label: "اليوم", value: "1"},
      { label: "الاسبوع الحالى", value: "2" },
      { label: "الاسبوع القادم", value: "3" },
      { label: "محدد", value: "4" }
    ];
  }
  loadDoctorAppointmentsData()
  {
    if((this.selectedSpecialty == null || this.selectedSpecialty == undefined) && (this.selectedDoctor == null || this.selectedDoctor ==undefined)){
      this.messageService.add({severity: 'warn', summary: 'تحذير', detail:"من فضلك ادخل التخصص او الدكتور", life: 2000});
      return;
    }
    this.isLoading = true;
    this.cd.detectChanges();
    var doctorAppointmentUrl = `/api/Queue/GetDoctorAppointments?specialtyId=${this.selectedSpecialty}&doctorId=${this.selectedDoctor}&dateCriteria=${+this.selectedDate}&customDateStr=${this.selectedCustomDate.toLocaleDateString()}`;
    this.helperService.getRequest(doctorAppointmentUrl).subscribe(response => {
      this.doctorAppointments = response?.Data;
      if(response.Success)
      {
        if(this.doctorAppointments.length == 0)
        {
          this.messageService.add({severity: 'warn', summary: 'تحذير', detail:"لا يوجد مواعيد متاحه", life: 2000});
        }
      }
      else
      {
          this.messageService.add({severity: 'error', summary: 'خظأ', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'خظأ', detail: error, life: 2000});
      this.isLoading = false;
    })
  }
  SetColHeadersWithDates(){
    var firstDay;
    var lastDay;
    var currentDate = new Date();
    if(this.selectedDate == 1 || this.selectedDate == 2){
      currentDate = new Date();
      var dayName = this.days[currentDate.getDay()];
      if(dayName == 'Saturday'){
        firstDay = currentDate;
      }else{
        firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() -1));
      }
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    else if(this.selectedDate == 3){
      currentDate = new Date();
      firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    else if(this.selectedDate == 4){
      currentDate = new Date(this.selectedCustomDate);
      var dayName = this.days[currentDate.getDay()];
      if(dayName == 'Saturday'){
        firstDay = currentDate;
      }else{
        firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() -1));
      }
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    var monthNumber = firstDay.getMonth() + 1;
    this.satDate = " ("+firstDay.getDate()+"/"+monthNumber+") ";
    
    var sunDate= new Date(firstDay);
    sunDate.setDate(sunDate.getDate() + 1);
    var sunDateMonth = sunDate.getMonth() + 1;
    this.sunDate = " ("+(sunDate.getDate())+"/"+sunDateMonth+") ";

    var monDate = new Date(firstDay);
    monDate.setDate(monDate.getDate() + 2);
    var monDateMonth = monDate.getMonth() + 1;
    this.monDate = " ("+(monDate.getDate())+"/"+monDateMonth+") ";

    var tuesDate = new Date(firstDay);
    tuesDate.setDate(tuesDate.getDate() + 3);
    var tuesDateMonth = tuesDate.getMonth() + 1;
    this.tuesDate = " ("+(tuesDate.getDate())+"/"+tuesDateMonth+") ";

    var wedDate = new Date(firstDay);
    wedDate.setDate(wedDate.getDate() + 4);
    var wedDateMonth = wedDate.getMonth() + 1;
    this.wedDate = " ("+(wedDate.getDate())+"/"+wedDateMonth+") ";

    var thursDate = new Date(firstDay);
    thursDate.setDate(thursDate.getDate() + 5);
    var thurDateMonth = thursDate.getMonth() + 1;
    this.thurDate = " ("+(thursDate.getDate())+"/"+thurDateMonth+") ";

    var fridDate = new Date(firstDay);
    fridDate.setDate(fridDate.getDate() + 6);
    var fridDateMonth = fridDate.getMonth() + 1;
    this.firdDate = " ("+(fridDate.getDate())+"/"+fridDateMonth+") ";
  }
}
